// core/disposers.js — DisposerBag: collects teardown functions (e.g. the disposer returned by
// mediator.subscribe) and calls them together on dispose(). One bag = one lifecycle scope.
//
// Extracted (frontend_view-state-base, Phase base) from the hand-rolled cleanup patterns across the
// codebase — TagEventLinker collected them by hand, EventLinker/OverlayAdminController/MapController
// forgot to (mediator-subscribe-cleanup-leaks). This is the single collect-and-teardown convention.

export function createDisposers() {
    const bag = [];
    return {
        // Takes one or more disposers (truthy functions); returns the last one so it can be used
        // inline: bag.add(mediator.subscribe(...))  — or in batch: bag.add(subA, subB, subC).
        add(...disposers) {
            for (const d of disposers) { if (typeof d === 'function') { bag.push(d); } }
            return disposers[disposers.length - 1];
        },
        // Calls all collected disposers and empties the bag (idempotent: a second call is a no-op).
        dispose() {
            for (const d of bag) { d(); }
            bag.length = 0;
        },
    };
}
